import DOMPurify from 'dompurify'
import * as showdown from 'showdown'

const s = showdown
s.setFlavor('github')

const converter = new showdown.Converter({
	literalMidWordUnderscores: true
});

export default {
	// Showdown passes raw HTML through and its output goes into dangerouslySetInnerHTML,
	// so it must be sanitized: the input can be written by anonymous widget visitors.
	makeHtml: (text: string) => DOMPurify.sanitize(converter.makeHtml(text), { ADD_ATTR: ['target'] }),
};
